import React, { useState } from "react";

function FixedMovementModal(props) {
    const { metodiPagamento, onClose, onSave } = props;

    const [soggetto, setSoggetto] = useState("");
    const [importo, setImporto] = useState("");
    const [eu, setEu] = useState(false); // false = uscita, true = entrata
    const [idMetodo, setIdMetodo] = useState(metodiPagamento[0]?.id || "");
    const [giornoMese, setGiornoMese] = useState("15");
    const [dataRiferimento, setDataRiferimento] = useState(new Date().toISOString().split('T')[0]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!soggetto.trim() || !importo || !dataRiferimento || !giornoMese) {
            alert("Compila tutti i campi obbligatori!");
            return;
        }

        onSave({
            soggetto,
            importo: parseFloat(importo),
            eu,
            id_metodo: idMetodo ? parseInt(idMetodo) : null,
            giorno_mese: parseInt(giornoMese),
            data_inizio: dataRiferimento
        });
    };

    return (
        <div style={styles.modalOverlay}>
            <div style={styles.modalContent}>
                <h2>Nuovo Movimento Fisso</h2>
                <p style={styles.modalSubtitle}>Imposta una spesa o entrata ricorrente mensile</p>

                <form onSubmit={handleSubmit} style={styles.form}>
                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Tipo</label>
                        <select value={eu ? "true" : "false"} onChange={(e) => setEu(e.target.value === "true")} style={styles.input}>
                            <option value="false">🔴 Uscita</option>
                            <option value="true">🟢 Entrata</option>
                        </select>
                    </div>

                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Soggetto / Nome</label>
                        <input 
                            type="text" 
                            placeholder="es. Stipendio, Mutuo, Affitto" 
                            value={soggetto}
                            onChange={(e) => setSoggetto(e.target.value)}
                            style={styles.input}
                            required 
                        />
                    </div>

                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Importo (€)</label>
                        <input 
                            type="number" 
                            step="0.01" 
                            placeholder="0.00" 
                            value={importo}
                            onChange={(e) => setImporto(e.target.value)}
                            style={styles.input}
                            required 
                        />
                    </div>

                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Metodo / Conto di riferimento</label>
                        <select value={idMetodo} onChange={(e) => setIdMetodo(e.target.value)} style={styles.input}>
                            {metodiPagamento.map(m => (
                                <option key={m.id} value={m.id}>
                                    {m.nome} {m.conto ? `(${m.conto})` : ''}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Giorno del mese (1 - 31)</label>
                        <input 
                            type="number" 
                            min="1" 
                            max="31" 
                            value={giornoMese}
                            onChange={(e) => setGiornoMese(e.target.value)}
                            style={styles.input}
                            required 
                        />
                    </div>

                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Data di Inizio (Primo mese di attivazione)</label>
                        <input 
                            type="date" 
                            value={dataRiferimento}
                            onChange={(e) => setDataRiferimento(e.target.value)}
                            style={styles.input}
                            required 
                        />
                    </div>

                    <div style={styles.modalButtons}>
                        <button type="submit" style={styles.saveBtn}>Salva</button>
                        <button type="button" onClick={onClose} style={styles.cancelBtn}>Annulla</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

const styles = {
    modalOverlay: { position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0, 0, 0, 0.75)', backdropFilter: 'blur(4px)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 },
    modalContent: { backgroundColor: '#1e293b', padding: '28px', borderRadius: '16px', width: '100%', maxWidth: '420px', color: '#ffffff', border: '1px solid #334155', boxShadow: '0 25px 30px -10px rgba(0,0,0,0.6)', textAlign: 'center' },
    modalSubtitle: { color: '#94a3b8', fontSize: '0.9rem', marginTop: '-4px', marginBottom: '15px' },
    form: { display: 'flex', flexDirection: 'column', gap: '12px', textAlign: 'left' },
    inputGroup: { display: 'flex', flexDirection: 'column', gap: '4px' },
    label: { fontSize: '0.85rem', color: '#cbd5e1', fontWeight: '500' },
    input: { padding: '10px 12px', borderRadius: '6px', border: '1px solid #475569', background: '#0f172a', color: '#ffffff', fontSize: '0.95rem', outline: 'none' },
    modalButtons: { display: 'flex', gap: '10px', marginTop: '15px' },
    saveBtn: { flex: 1, backgroundColor: '#22c55e', color: '#0f172a', border: 'none', padding: '11px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' },
    cancelBtn: { flex: 1, backgroundColor: 'transparent', color: '#cbd5e1', border: '1px solid #475569', padding: '11px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }
};

export default FixedMovementModal;